import { Selector } from 'controllers/tied'
import { SharedStorageVerificacao } from './_data'

type VerificacaoSelector = Selector<SharedStorageVerificacao>

export const broadcast_verificacao: VerificacaoSelector = verificacao => verificacao